// PowerBIWebSocketService.js

import actions from '@flux/action';

export class PowerBIWebSocketService {
  constructor(url, store, buttonId) {
    this.url = url;
    this.store = store;
    this.buttonId = buttonId;
    this.socket = null;
  }

  connect() {
    if (!this.url) {
      return;
    }
    try {
      this.socket = new WebSocket(this.url);
    } catch (error) {
      console.warn('PBI: WebSocket connect failed', error);
      return;
    }

    this.socket.onopen = () => {
      const buttonID = this.buttonId;
      this.sendButtonId(JSON.stringify({ buttonID }));
    };

    this.socket.onmessage = async (event) => {
      const { buttonList, message, type } = JSON.parse(event.data);
      this.store.dispatch(
        actions.websocketMessageReceived(buttonList, message, type),
      );
    };

    this.socket.onclose = () => {
      console.log(' PBI : WebSocket closed');
    };

    this.socket.onerror = (error) => {
      console.warn('PBI: WebSocket error', error);
    };
  }

  sendButtonId(buttonId) {
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      this.socket.send(JSON.stringify(buttonId));
    } else {
      console.error('WebSocket is not open');
    }
  }

  close() {
    if (this.socket) {
      this.socket.close();
    }
  }
}
